// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"0e15ef6b","593":"8242f9e2","684":"ed3e19bc","848":"3f36b8c7","850":"be6f7cf5","945":"2134c5e7"}[chunkId] + ".chunk.js";
};